import { combineReducers } from "redux";
import chargePointReducer from "./chargePoint.reducer";
import transactionPaymentReducer from "./transactions/transactionPayment.reducer";
import transactionClientReducer from "./transactions/transactionClient.reducer";
import chargingTransactionReducer from "./transactions/chargingTransaction.reducer";
import companyReducer from "./company/company.reducer";

const rootReducer = combineReducers({
  chargePointReducer: chargePointReducer,
  transactionClientReducer: transactionClientReducer,
  transactionPaymentReducer: transactionPaymentReducer,
  chargingTransactionReducer: chargingTransactionReducer,
  companyReducer: companyReducer,
});

export default rootReducer;
